import axiosInstance from "../axios/axios";

const projectList = async (body) => {
  try {
    const response = await axiosInstance.post("/Project/getAllProjects", body); // replace with your endpoint
    //console.log("projectList--->", response?.data);
    return response;
  } catch (error) {
    console.error("Error fetching projectList:", error);
  }
};

const getAllVendors = async (id) => {
  try {
    const response = await axiosInstance.get(`/Vendor/getAllVendors/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching vendors:", error);
  }
};
const getVendorsByProjectType = async (userId, companyId, projectTypeId) => {
  try {
    const response = await axiosInstance.get(`/Project/getVendorsByProjectType/${userId}/${companyId}/${projectTypeId}`);
    return response;
  } catch (error) {
    console.error("Error fetching vendors:", error);
  }
};
const addProject = async (userId, companyId, projectData) => {
  try {
    const response = await axiosInstance.post(`/Project/addProject/${userId}/${companyId}`, projectData);
    return response;
  } catch (error) {
    console.error("Error adding project:", error);
    throw error;
  }
};
const updateProject = async (userId, companyId, projectData) => {
  try {
    const response = await axiosInstance.post(`/Project/updateProject/${userId}/${companyId}`, projectData);
    return response;
  } catch (error) {
    console.error("Error adding project:", error);
    throw error;
  }
};
const updateProjectStatus = async (userId, companyId, projectStatusData) => {
  try {
    const response = await axiosInstance.post(`/Project/updateProjectStatus/${userId}/${companyId}`, projectStatusData);
    return response;
  } catch (error) {
    console.error("Error adding project:", error);
    throw error;
  }
};
const getProjectById = async (userId, companyId, id) => {
  try {
    const response = await axiosInstance.get(`/Project/getProjectById/${userId}/${companyId}/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching project by ID:", error);
  }
}
const addProjectDocument = async (userId, companyId, projectData) => {
  try {
    const response = await axiosInstance.post(`/Project/addProjectDocument/${userId}/${companyId}`, projectData);
    return response;
  } catch (error) {
    console.error("Error adding project document:", error);
    throw error;
  }
}
const deleteProjectDocument = async (userId, companyId, id) => {
  try {
    const response = await axiosInstance.post(`/Project/deleteProjectDocument/${userId}/${companyId}/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting project document:", error);
    throw error;
  }
}
const addProjectOwner = async (userId, companyId, projectOwnerId, body) => {
  try {
    const response = await axiosInstance.post(`/Project/addProjectOwner/${userId}/${companyId}/${projectOwnerId}`, body);
    return response;
  } catch (error) {
    console.error("Error adding project owner:", error);
    throw error;
  }
}
export const ProjectService = {
  projectList,
  getAllVendors,
  addProject,
  getProjectById,
  addProjectDocument,
  updateProject,
  updateProjectStatus,
  deleteProjectDocument,
  getVendorsByProjectType,
  addProjectOwner

};
